<template>
  <b-modal
    id="assign-merchant-modal"
    cancel-variant="outline-secondary"
    centered
    no-close-on-backdrop
    :cancel-title="$t('button.close')"
    :title="$t('chat.transferToMerchant')"
    @ok="handleOk"
  >
    <validation-observer ref="assignMerchantFrom" #default="{ invalid }">
      <!-- form -->
      <n-form-confirmation
        ref="formConfirmation"
        key="assignMerchantFrom"
        :message="$t('alert.assignTo', { operator: data.toMerchantName })"
        :confirm-button-text="`button.confirm`"
        :cancel-button-text="`button.no`"
        :form="$refs.assignMerchantFrom"
        :disabled="invalid"
        @submit="submit"
      >
        <n-input :fields="formInput" v-model="data">
          <template #toMerchantId="item">
            <b-form-group
              :label-for="item.field.key"
              :class="item.field.class"
              :key="`selection-operator-${key}`"
            >
              <validation-provider
                #default="{ errors }"
                :vid="item.field.key"
                :name="item.field.label"
                :rules="item.field.rules"
              >
                <label class="d-block">
                  {{ $t("field.merchant") }}
                </label>
                <n-async-single-select
                  v-model="dataSelect"
                  :ref="item.field.key"
                  :name="item.field.key"
                  :repository="item.field.repository"
                  :selection-key="item.field.selectionKey"
                  :selection-label="item.field.selectionLabel"
                  :readonly="item.field.disabled"
                  :clearable="item.field.clearable"
                  :reduce="false"
                  @input="onChangeMerchant"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <template #option="item">
                    {{ item.companyName }}
                  </template>
                </n-async-single-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </template>
        </n-input>
      </n-form-confirmation>
    </validation-observer>

    <template #modal-ok>
      <b-spinner small label="Spinning" v-if="loading"></b-spinner>
      <span v-else>
        {{ $t("chat.transferToMerchant") }}
      </span>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BSpinner, BFormGroup, BBadge } from "bootstrap-vue";
import FormInput from "./assignMerchantFormInput";
import NInput from "@/components/NInput";
import Repository from "@/repositories/RepositoryFactory";
import NFormConfirmation from "@/components/NFormConfirmation";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect.vue";
import useJwt from "@/auth/jwt/useJwt";

const ChatChannelRepository = Repository.get("chatChannel");

export default {
  components: {
    BModal,
    BSpinner,
    BFormGroup,
    BBadge,
    NFormConfirmation,
    NInput,
    NAsyncSingleSelect,
  },
  computed: {},
  props: {
    activeChannel: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  data() {
    return {
      loading: false,
      data: {
        fromMerchantId: "",
        toMerchantId: "",
        toMerchantName: "",
      },
      dataSelect: "",
      merchantName: "",
      key: 1,
    };
  },
  methods: {
    show() {
      this.key++;
      this.data.fromMerchantId = "";
      this.data.toMerchantId = "";
      this.data.toMerchantName = "";
      this.dataSelect = "";
      this.$bvModal.show("assign-merchant-modal");
    },
    hide() {
      this.data.fromMerchantId = "";
      this.data.toMerchantId = "";
      this.data.toMerchantName = "";
      this.dataSelect = "";
      this.$bvModal.hide("assign-merchant-modal");
    },
    onChangeMerchant(data) {
      this.data.fromMerchantId = this.userData.merchantId;
      this.data.toMerchantId = data.id;
      this.data.toMerchantName = data.companyName;
    },
    handleOk(bvModal) {
      bvModal.preventDefault();
      if (this.loading) {
        return;
      }

      this.$refs.assignMerchantFrom.validate().then((success) => {
        if (success) {
          this.$refs.formConfirmation.confirm();
        }
      });
    },
    submit() {
      this.loading = true;
      const fromChannel = this.activeChannel.id;
      const to = this.data.toMerchantId;

      ChatChannelRepository.crossTransfer({ fromChannel, to })
        .then((response) => {
          this.hide();
          this.$emit("success");
        })
        .catch((error) => {
          if (error.response?.status == 422) {
            this.$refs.assignMerchantFrom.setErrors(
              error.response?.data?.validate
            );
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const formInput = [...FormInput];

    return {
      formInput,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
